<div>
    <table class="table table-striped ">

        <thead>
            <th scope="col">{{'Value' | i18n}}</th>
            <th scope="col">{{'Score' | i18n}}</th>
        </thead>
        <tbody>
            <tr *ngFor="let item of autoCompleteList; let i = index" (click)="clickItem($event, item)" >
                <td>
                    {{item['word']['text']}}
                </td>
                <td>
                    % {{printScore(item)}}
                </td>
            </tr>
        </tbody>

        
        <div [className]="'replaceBtnContain'">
            <div>
                <button (click)=cancel()> אישור </button>
            </div>
        </div>
    </table>


</div>